import { IChartBaseStyle } from '../models/index.js';
export const chartBaseStyle: IChartBaseStyle = {
	height: '500px',
	children: {
		defaultLegendContent: {
			color: '#777',
		},
		chartSummary: {
			text: {
				align: 'center',
			},
		},
	},
};
